import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import AllProjects from "../components/projects/allProjects";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/projects.css";

const Projects = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "projects");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Projetos | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="projects" />
				<div className="content-wrapper">
					<div className="projects-logo-container">
						<div className="projects-logo">
							<Logo width={46} />
						</div>
					</div>
					<div className="projects-container">
						<div className="title projects-title">
							Alguns dos meus projetos para deixar minha marca.
						</div>

						<div className="subtitle projects-subtitle">
						Ao longo dos anos, trabalhei em uma variedade de projetos 
						e estou orgulhoso do progresso que fiz. Muitos desses 
						projetos são de código aberto e estão disponíveis para que 
						outras pessoas explorem e contribuam - você pode conferir no meu GitHub. 
						Se você estiver interessado em algum dos projetos
						para sugerir quaisquer melhorias ou aprimoramentos. 
						Colaborar com outras pessoas é uma ótima maneira de aprender e 
						crescer, e estou sempre aberto a novas ideias e feedbacks.
						</div>

						<div className="projects-list">
							<AllProjects />
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Projects;
